import { format, startOfWeek, endOfWeek, startOfMonth, endOfMonth } from "date-fns";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

const iso = (d) => format(d, "yyyy-MM-dd");

export function rangeFor(preset) {
  const t = new Date();
  if (preset === "day") return [iso(t), iso(t)];
  if (preset === "week") return [iso(startOfWeek(t, { weekStartsOn: 1 })), iso(endOfWeek(t, { weekStartsOn: 1 }))];
  if (preset === "month") return [iso(startOfMonth(t)), iso(endOfMonth(t))];
  return null;
}

export default function PeriodSelector({ preset, start, end, onPreset, onRange, testid = "period" }) {
  const presets = [["day", "Day"], ["week", "Week"], ["month", "Month"], ["custom", "Custom"]];
  return (
    <div className="flex flex-wrap items-end gap-3" data-testid={`${testid}-selector`}>
      <div className="flex rounded-md border border-border overflow-hidden glass">
        {presets.map(([v, label]) => (
          <button key={v} type="button" data-testid={`${testid}-${v}`} onClick={() => onPreset(v)}
            className={`px-3.5 h-9 text-sm transition-colors ${preset === v ? "bg-primary text-white" : "text-foreground hover:bg-accent"}`}>
            {label}
          </button>
        ))}
      </div>
      {preset === "custom" && (
        <>
          <div className="space-y-1">
            <Label className="text-xs">From</Label>
            <Input type="date" data-testid={`${testid}-start`} value={start} onChange={(e) => onRange([e.target.value, end])} />
          </div>
          <div className="space-y-1">
            <Label className="text-xs">To</Label>
            <Input type="date" data-testid={`${testid}-end`} value={end} onChange={(e) => onRange([start, e.target.value])} />
          </div>
        </>
      )}
      <span className="text-xs text-muted-foreground pb-2 num" data-testid={`${testid}-range-label`}>{start} → {end}</span>
    </div>
  );
}

export function usePeriod(defaultPreset = "month") {
  // small hook kept next to the component: [state] + setPreset applies preset ranges automatically
  // (implemented inline in pages via useState to stay explicit)
  return null;
}
